var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveForwards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67082 10.6646C7.85606 11.0351 7.70589 11.4856 7.33541 11.6708L4.67705 13L10 15.6615L15.3229 13L12.6646 11.6708C12.2941 11.4856 12.1439 11.0351 12.3292 10.6646C12.5144 10.2941 12.9649 10.1439 13.3354 10.3292L17.3354 12.3292C17.5895 12.4562 17.75 12.7159 17.75 13C17.75 13.2841 17.5895 13.5438 17.3354 13.6708L10.3354 17.1708C10.1243 17.2764 9.87574 17.2764 9.66459 17.1708L2.66459 13.6708C2.4105 13.5438 2.25 13.2841 2.25 13C2.25 12.7159 2.4105 12.4562 2.66459 12.3292L6.66459 10.3292C7.03507 10.1439 7.48558 10.2941 7.67082 10.6646Z",
    fill: "#2B2B35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.5835C10.4142 2.5835 10.75 2.91928 10.75 3.3335V11.6668C10.75 12.081 10.4142 12.4168 10 12.4168C9.58579 12.4168 9.25 12.081 9.25 11.6668V3.3335C9.25 2.91928 9.58579 2.5835 10 2.5835Z",
    fill: "#2B2B35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.46967 2.80317C9.76256 2.51027 10.2374 2.51027 10.5303 2.80317L13.8637 6.1365C14.1566 6.42939 14.1566 6.90427 13.8637 7.19716C13.5708 7.49005 13.0959 7.49005 12.803 7.19716L9.46967 3.86383C9.17678 3.57093 9.17678 3.09606 9.46967 2.80317Z",
    fill: "#2B2B35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5307 2.80317C10.8235 3.09606 10.8235 3.57093 10.5307 3.86383L7.19732 7.19716C6.90443 7.49005 6.42956 7.49005 6.13666 7.19716C5.84377 6.90427 5.84377 6.42939 6.13666 6.1365L9.47 2.80317C9.76289 2.51027 10.2378 2.51027 10.5307 2.80317Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveForwards);
export default __webpack_public_path__ + "static/media/moveForwards.2761874a7a9e98ad869d98ef9f8cb494.svg";
export { ForwardRef as ReactComponent };